module.exports = __webpack_public_path__ + "packs/media/images/Back-f797ce87cabbd84858df2bf51e24e454.svg";